<template>
  <div class="text-center mt-5">
    <div
      class="spinner-border"
      role="status"
    >
      <span class="sr-only">
        Loading...
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RedirectPage',

  created () {
    this.$router.push({
      name: 'my_dhm',
      params: {
        fromEmail: true,
        idFromEmail: this.$route.query.id
      }
    })
  }
}
</script>

<style scoped>

</style>
